import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupUnion2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"boolean-group-union-2"} maskId="square-filled-radius-0-stroke-1-IconBooleanGroupUnion2"><path fillRule="evenodd" clipRule="evenodd" d="M8 2V8H2V22H16V16H22V2H8ZM13 16H8V11H9V15H13V16ZM11 8V9H15V13H16V8H11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBooleanGroupUnion2;
